module.exports = __webpack_public_path__ + "img/yxlogo_black.f4aecdc6.png";